import React, { useEffect, useState } from 'react';
import { PanelSection } from '../shared/property-rows';

interface LeadCommentsSectionProps {
  selectedClient: any;
  handleLeadUpdate: (id: string, updates: any) => Promise<boolean>;
}

/**
 * Sezione "Commenti" del pannello dettagli: toggle aperto con lo stesso blocco
 * click-to-edit di prima (textarea, Salva/Annulla, salvataggio su blur).
 */
export function LeadCommentsSection({ selectedClient, handleLeadUpdate }: LeadCommentsSectionProps) {
  const [editing, setEditing] = useState(false);
  const [value, setValue] = useState(selectedClient?.general_comments || '');

  useEffect(() => {
    setValue(selectedClient?.general_comments || '');
    setEditing(false);
  }, [selectedClient?.id]);

  const save = async () => {
    setEditing(false);
    const newValue = value.trim();
    const oldValue = (selectedClient.general_comments || '').trim();
    if (newValue !== oldValue) {
      await handleLeadUpdate(selectedClient.id, { general_comments: newValue || null });
    }
  };

  return (
    <PanelSection title="Commenti" defaultOpen summary={value ? undefined : 'Vuoto'}>
      <div className="px-1.5 py-0.5">
        {editing ? (
          <div className="space-y-1">
            <textarea
              autoFocus
              value={value}
              onChange={(e) => setValue(e.target.value)}
              onBlur={save}
              onKeyDown={(e) => {
                if (e.key === 'Escape') {
                  e.preventDefault();
                  setValue(selectedClient?.general_comments || '');
                  setEditing(false);
                }
              }}
              rows={4}
              className="w-full resize-none rounded border border-[rgba(55,53,47,0.16)] bg-[rgba(55,53,47,0.04)] px-2 py-1.5 text-[13px] leading-relaxed text-[#37352F] focus:outline-none focus:ring-1 focus:ring-[#337EA9] dark:border-gray-600 dark:bg-white/[0.05] dark:text-gray-200 dark:focus:ring-[#529CCA]"
              placeholder="Aggiungi commenti generali..."
            />
            <div className="flex justify-end gap-2">
              <button
                onMouseDown={(e) => { e.preventDefault(); setValue(selectedClient?.general_comments || ''); setEditing(false); }}
                className="rounded px-2 py-0.5 text-xs text-[#787774] transition-colors hover:bg-[rgba(55,53,47,0.06)] hover:text-[#37352F] dark:text-gray-400 dark:hover:bg-white/[0.05] dark:hover:text-gray-200"
              >
                Annulla
              </button>
              <button
                onMouseDown={(e) => { e.preventDefault(); save(); }}
                className="rounded bg-[#337EA9] px-2 py-0.5 text-xs text-white transition-colors hover:bg-[#2d6f95]"
              >
                Salva
              </button>
            </div>
          </div>
        ) : value ? (
          <p
            className="cursor-pointer whitespace-pre-wrap rounded px-1 py-0.5 text-[13px] leading-relaxed text-[#37352F] transition-colors hover:bg-[rgba(55,53,47,0.04)] dark:text-gray-200 dark:hover:bg-white/[0.03]"
            onClick={() => setEditing(true)}
          >
            {value}
          </p>
        ) : (
          <p
            className="cursor-pointer rounded px-1 py-0.5 text-[13px] italic text-[rgba(55,53,47,0.45)] transition-colors hover:bg-[rgba(55,53,47,0.04)] dark:text-gray-500 dark:hover:bg-white/[0.03]"
            onClick={() => setEditing(true)}
          >
            Aggiungi commenti...
          </p>
        )}
      </div>
    </PanelSection>
  );
}
